import { render } from "./TwoFactorSetup.vue?vue&type=template&id=66120b75&scoped=true"
import script from "./TwoFactorSetup.vue?vue&type=script&lang=js"
export * from "./TwoFactorSetup.vue?vue&type=script&lang=js"

import "./TwoFactorSetup.vue?vue&type=style&index=0&id=66120b75&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66120b75"]])

export default __exports__